const FALLBACK_SYMBOLS = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£'
}

export function getCurrencySymbol (code) {
  const normalized = String(code || 'INR').trim().toUpperCase()
  try {
    const parts = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: normalized,
      currencyDisplay: 'narrowSymbol'
    }).formatToParts(0)
    const currencyPart = parts.find((p) => p.type === 'currency')
    const symbol = currencyPart && currencyPart.value
    if (symbol && symbol !== normalized) {
      return symbol
    }
  } catch (e) {
    // ignore
  }
  return FALLBACK_SYMBOLS[normalized] || normalized
}

export function formatMoney (amount, code = 'INR') {
  const normalized = String(code || 'INR').trim().toUpperCase()
  const value = Number(amount) || 0
  try {
    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency: normalized,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 2
    }).format(value)
  } catch (e) {
    return `${getCurrencySymbol(normalized)} ${value}`
  }
}
